import React from 'react';

import FormGroupWrapper from '@/features/sampleDevelopment/components/SampleRequestModals/FormGroupWrapper';
import CustomDropdown from '@/components/CustomDropdown';
import InputField from '@/components/InputField';
import InputWrapper from '@/features/sampleDevelopment/components/SampleRequestModals/InputWrapper';
import { useGetFactoryListQuery } from '@/api/commonApis';
import {
	formatFactoryOptions,
	formatProjectDealOptions,
	formatSampleTypeOptions
} from '@/features/sampleDevelopment/utils';

const SendToFactoryBuyerDevForm = ({
	handleChange,
	requestValues,
	errors,
	brands = [],
	sampleTypeList = [],
	isDisabeleBrand,
	isDisabledProjectTeam,
	isDisabledProjectAndAm,
	projectDealList
}) => {
	const { data: factoryList } = useGetFactoryListQuery({ params: { page: 0, size: 1000 } });

	return (
		<React.Fragment>
			<div className="flied-item d-grid grid-columns-2 gap-3">
				<FormGroupWrapper labelTitle="Customer name">
					<CustomDropdown
						title="Select brand"
						onItemClick={(value) => handleChange('brand', value)}
						selectedItem={
							requestValues?.primaryTargetCustomar?.name || requestValues?.brand?.name
						}
						items={brands?.map((brand) => ({
							...brand,
							value: brand.name
						}))}
						isDisabled={isDisabeleBrand}
					/>
				</FormGroupWrapper>
				<FormGroupWrapper labelTitle="Deal*">
					<div className={!requestValues?.brand?.id ? 'cursor-none' : ''}>
						<CustomDropdown
							title="Select"
							onItemClick={(value) => {
								handleChange('projectDealName', value);
								handleChange('dealId', value?.dealId);
							}}
							selectedItem={
								requestValues?.projectDealName?.dealName ||
								requestValues?.projectDealName?.value
							}
							items={formatProjectDealOptions(projectDealList)}
							toolTipLength={25}
						/>
					</div>
					{errors?.projectDealName && <p className="error">{errors?.projectDealName}</p>}
				</FormGroupWrapper>
			</div>
			<div className="flied-item d-grid grid-columns-2 gap-3">
				<FormGroupWrapper labelTitle="Sample type*">
					<CustomDropdown
						title="Select sample type"
						onItemClick={(value) => handleChange('sampleType', value)}
						selectedItem={requestValues?.sampleType?.value}
						items={formatSampleTypeOptions(sampleTypeList)}
					/>
					{errors?.sampleType && <p className="error">{errors?.sampleType}</p>}
				</FormGroupWrapper>

				<InputWrapper
					labelTitle={`Factory submission to AM/BDM plan date${isDisabledProjectTeam ? '*' : ''}`}
				>
					<InputField
						type="date"
						name="factorySubmitionToNitexDate"
						value={requestValues?.factorySubmitionToNitexDate}
						onChangeHandler={(e) => handleChange('factorySubmitionToNitexDate', e.target.value)}
						withWrapper={false}
						withLabel={false}
						errors={isDisabledProjectTeam ? errors?.factorySubmitionToNitexDate : null}
						isDisabled={!isDisabledProjectTeam}
						className={`${!isDisabledProjectTeam ? 'cursor-none' : ''}`}
					/>
				</InputWrapper>
				<FormGroupWrapper labelTitle="Factory name*">
					<CustomDropdown
						title="Select factory name"
						onItemClick={(value) => handleChange('factoryName', value)}
						selectedItem={requestValues?.factoryName?.name}
						items={formatFactoryOptions(factoryList)}
					/>
					{errors?.factoryName && <p className="error">{errors?.factoryName}</p>}
				</FormGroupWrapper>
			</div>
			<div className={`${!isDisabledProjectAndAm ? 'd-none' : ''}`}>
				<div className="mb-2">
					<span className="regular-14 weight-500">AM Section</span>
				</div>
				<div className="flied-item d-grid grid-columns-2 gap-3">
					<InputWrapper
						labelTitle={`Sample dispatch from BD - Due date${isDisabledProjectAndAm ? '*' : ''}`}
					>
						<InputField
							type="date"
							name="requiredDate"
							value={requestValues?.requiredDate}
							onChangeHandler={(e) => handleChange('requiredDate', e.target.value)}
							withWrapper={false}
							withLabel={false}
							errors={isDisabledProjectAndAm ? errors?.buyerRequiredDate : null}
							isDisabled={!isDisabledProjectAndAm}
							className={`${!isDisabledProjectAndAm ? 'cursor-none' : ''}`}
						/>
					</InputWrapper>

					<InputWrapper labelTitle={`Buyer selection date${isDisabledProjectAndAm ? '*' : ''}`}>
						<InputField
							type="date"
							name="expectedOrderDate"
							value={requestValues?.expectedOrderDate}
							onChangeHandler={(e) => handleChange('expectedOrderDate', e.target.value)}
							required={isDisabledProjectAndAm}
							withWrapper={false}
							withLabel={false}
							errors={isDisabledProjectAndAm ? errors?.expectedOrderDate : null}
						/>
					</InputWrapper>
				</div>
			</div>
		</React.Fragment>
	);
};

export default SendToFactoryBuyerDevForm;
